export const LIST_COLORS = [
  '#e6194B',
  '#3cb44b',
  '#4363d8',
  '#f58231',
  '#911eb4',
  '#f032e6',
  '#bfef45',
  '#fabebe',
  '#469990',
  '#9A6324',
  '#fffac8',
  '#aaffc3',
  '#808000',
  '#ffd8b1',
  '#000075',
  '#a9a9a9',
  '#800000',
  '#42d4f4',
  '#ffffff',
  '#000000',
];

const COLORS = [
  '#EC644B',
  '#D24D57',
  '#F22613',
  '#D91E18',
  '#96281B',
  '#EF4836',
  '#D64541',
  '#C0392B',
  '#CF000F',
  '#E74C3C',
  '#DB0A5B',
  '#F64747',
  '#F1A9A0',
  '#D2527F',
  '#E08283',
  '#F62459',
  '#E26A6A',
  '#DCC6E0',
  '#663399',
  '#674172',
  '#AEA8D3',
  '#913D88',
  '#9A12B3',
  '#BF55EC',
  '#BE90D4',
  '#8E44AD',
  '#9B59B6',
  '#446CB3',
  '#4183D7',
  '#59ABE3',
  '#81CFE0',
  '#52B3D9',
  '#22A7F0',
  '#3498DB',
  '#19B5FE',
  '#336E7B',
  '#6BB9F0',
  '#1E8BC3',
  '#3A539B',
  '#67809F',
  '#2574A9',
  '#1F3A93',
  '#89C4F4',
  '#4B77BE',
  '#5C97BF',
  '#4ECDC4',
  '#87D37C',
  '#90C695',
  '#26A65B',
  '#03C9A9',
  '#68C3A3',
  '#65C6BB',
  '#1BBC9B',
  '#1BA39C',
  '#66CC99',
  '#36D7B7',
  '#C8F7C5',
  '#86E2D5',
  '#2ECC71',
  '#16A085',
  '#3FC380',
  '#019875',
  '#03A678',
  '#4DAF7C',
  '#2ABB9B',
  '#00B16A',
  '#1E824C',
  '#049372',
  '#26C281',
  '#F7CA18',
  '#F4D03F',
  '#E9D460',
  '#F89406',
  '#EB9532',
  '#E87E04',
  '#F4B350',
  '#F2784B',
  '#EB974E',
  '#F5AB35',
  '#D35400',
  '#F39C12',
  '#F9690E',
  '#F9BF3B',
  '#F27935',
  '#E67E22',
];

export const getRandomColor = (colorsUsed: string[]) => {
  const size = COLORS.length;

  if (colorsUsed) {
    return COLORS.filter((color) => !colorsUsed.includes(color))[
      Math.random() * size
    ];
  }

  return COLORS[Math.random() * size];
};
